/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkspaceMenuSettingsReplaceRequest } from '../models/WorkspaceMenuSettingsReplaceRequest';
import type { WorkspaceMenuSettingsResponse } from '../models/WorkspaceMenuSettingsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkspaceMenuService {
    /**
     * Replace Workspace Menu Settings
     * 워크스페이스 사이드바 메뉴 설정 전체 교체.
     *
     * items에 보내지 않은 menu_key는 삭제된다. 같은 depth(같은 parent_key) 내에서만
     * sort_order로 순서가 결정되며, parent_key가 다른 항목 간 순서는 의미 없음.
     *
     * ⚠️ **권한 필요**: 기관 소유자(owner) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns WorkspaceMenuSettingsResponse OK
     * @throws ApiError
     */
    public static appsWorkspaceViewsReplaceWorkspaceMenuSettings({
        workspaceId,
        requestBody,
    }: {
        workspaceId: string,
        requestBody: WorkspaceMenuSettingsReplaceRequest,
    }): CancelablePromise<WorkspaceMenuSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/workspace/{workspace_id}/menu-settings',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
